export default {
  widgets: {
    clientCommonFilesPanel: {
      title: 'Дополнительные файлы',
      addCommonFileTitle: 'Добавить дополнительный файл',
    },
  },
};
